export default __webpack_public_path__ + "static/media/v2-story-3.a18a42c0.jpg";